import { useMediaQuery } from "react-responsive";
import { Text } from "../../../../../../library/text";
import { Title } from "../../../../../../library/title";
//import DeleteAccount from "./delete-account";
import {
  Container,
  ContentWrapper,
  DisplayRow,
  InputWrapper,
  TextWrapper,
  UpperContainer,
  UpperTextWrapper,
} from "./styled";
import UpdateName from "./update-name";
import UpdatePassword from "./update-password";
import UpdatePhone from "./update-phone";
import { MOBILE_VIEW } from "../../../../../../variables";

const UserDetails = () => {
  const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_VIEW}px)` });

  const OPTIONS = [
    {
      title: "Fullt navn",
      description: "Oppdater navnet ditt",
      display: <UpdateName />,
    },
    {
      title: "Telefonnummer",
      description: "Oppdater telefonnummer",
      display: <UpdatePhone />,
    },
    {
      title: "Passord",
      description: "Endre passordet ditt",
      display: <UpdatePassword />,
    },
    /*
    {
      title: "Slett meg",
      description: "Slett kontoen din permanent",
      display: <DeleteAccount />,
    },
    */
  ];

  return (
    <Container>
      <UpperContainer>
        <UpperTextWrapper>
          <Title size="sm">Brukerinformasjon</Title>
          <Text size="small" color="dark">
            Oppdater kontoinformasjonen din for å holde den oppdatert.
          </Text>
        </UpperTextWrapper>
      </UpperContainer>
      <ContentWrapper>
        {OPTIONS.map((option, index) => (
          <DisplayRow key={index}>
            <TextWrapper>
              <Title size="xxs">{option.title}</Title>
              {!isMobile && (
                <Text size="small" color="dark">
                  {option.description}
                </Text>
              )}
            </TextWrapper>
            <InputWrapper>{option.display}</InputWrapper>
          </DisplayRow>
        ))}
      </ContentWrapper>
    </Container>
  );
};

export default UserDetails;
